import type { SxProps, Theme } from '@mui/material';

export const displayTotalSx: SxProps<Theme> = {
  typography: 'body2',
  alignItems: 'center',
  display: 'inline-flex',
  justifyContent: 'center',
};

export const viewDetailsWrapperSx: SxProps<Theme> = {
  position: 'absolute',
  bottom: 16,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 1,
};

export const viewDetailsButtonSx: SxProps<Theme> = {
  borderRadius: '50px',
  p: 2,
  py: 2.5,
  fontSize: '14px',
};
